import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ReportTypeActions from './actions';
import { IReportType } from '@app/models/report-type';
import { environment } from 'src/environments/environment';
import { RootStoreState } from '..';
import { HttpService } from '@surveyname/common';
import { IVersion } from '@app/models/version';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';

@Injectable()
export class ReportTypeEffects {
  constructor(
    private http: HttpService,
    private action$: Actions
  ) {}

  GetReportTypesByProjectType$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(ReportTypeActions.BeginGetReportTypesByProjectTypeAction),
      mergeMap((action) =>
        this.http
          .get(
            `${environment.reportsApi}/viewer/report/projectType/${action.payload.projectTypeId}`
          )
          .pipe(
            map((reportTypes: IReportType[]) => {
              return ReportTypeActions.ReportTypesLoadedAction({
                payload: reportTypes,
              });
            }),
            catchError((error: Error) => {
              return of(ReportTypeActions.ErrorReport(error));
            })
          )
      )
    )
  );

  GetVersionsByReportType$: Observable<Action> = createEffect(() =>
  this.action$.pipe(
    ofType(ReportTypeActions.BeginGetVersionsByReportTypeAction),
    mergeMap((action) =>
      this.http
        .get(
          `${environment.reportsApi}/viewer/version/report/${action.payload.reportTypeId}/project/${action.payload.projectId}`
        )
        .pipe(
          map((versions: IVersion[]) => {
            console.log(versions);
            return ReportTypeActions.VersionsLoadedAction({
              payload: versions,
            });
          }),
          catchError((error: Error) => {
            return of(ReportTypeActions.ErrorReport(error));
          })
        )
    )
  )
);

  // GetReportsProgress$: Observable<Action> = createEffect(() =>
  //   this.action$.pipe(
  //     ofType(ReportTypeActions.BeginGetReportsProgressAction),
  //     switchMap((action) =>
  //       timer(0, 5000).pipe(
  //         mergeMap(() =>
  //           this.http
  //             .get(
  //               `${environment.apiUrl}/reports/viewer/version/progress/project/${action.payload.projectId}`
  //             )
  //             .pipe(
  //               map((progress: any[]) => {
  //                 return ReportTypeActions.GetReportProgressSuccessAction({
  //                   payload: progress,
  //                 });
  //               }),
  //               catchError((error: Error) => {
  //                 return of(ReportTypeActions.ErrorReport(error));
  //               })
  //             )
  //         )
  //       )
  //     )
  //   )
  // );

  CreateReportType$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(ReportTypeActions.BeginCreateReportTypeAction),
      mergeMap((action) =>
        this.http
          .post(
            `${environment.reportsApi}/viewer/report/create/empty`,
            action.payload.reportType
          )
          .pipe(
            map((reportType: IReportType) => {
              return ReportTypeActions.SuccessCreateReportTypeAction({
                payload: { reportType },
              });
            }),
            catchError((error: Error) => {
              return of(ReportTypeActions.ErrorReport(error));
            })
          )
      )
    )
  );

  GenerateReport$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(ReportTypeActions.BeginGenerateReportAction),
      mergeMap((action) =>
        this.http
          .post(
            `${environment.apiUrl}/reports/viewer/version/generate/${action.payload.createReportData.projectId}`,
            action.payload.createReportData
          )
          .pipe(
            map((createdReport: IVersion) => {
              return ReportTypeActions.GenerateReportSuccessAction({
                payload: { createdReport },
              });
            }),
            catchError((error: Error) => {
              return of(ReportTypeActions.ErrorReport(error));
            })
          )
      )
    )
  );
}
